export default "__VITE_ASSET__793e6b6f__"